import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { allUserDraftsAtom, currentProjectDraftsAtom } from 'atoms';
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
import { DraftButtonWithDialog } from './components/draft-button-with-dialog';

export const Drafts = () => {
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery();
  const hasAccess = userPermissions?.ENABLE_ACTIVITY_FEED?.canRead;

  const location = useLocation();
  const isInsideProject = location.pathname.includes('/project-dashboard/');

  const allDrafts = useAtomValue(allUserDraftsAtom);
  const projectDrafts = useAtomValue(currentProjectDraftsAtom);

  const drafts = useMemo(() => {
    if (isInsideProject) return projectDrafts;

    // All-projects: filter pending media + sort by project (same as mobile)
    const filtered = allDrafts.filter((d) => !d.media?.some((m) => m.url === ''));
    const projectOrder = new Map<string, number>();
    filtered.forEach((d, i) => {
      const pid = d.projectId || '';
      if (!projectOrder.has(pid)) projectOrder.set(pid, i);
    });
    return [...filtered].sort((a, b) => {
      const aOrder = projectOrder.get(a.projectId || '') ?? 0;
      const bOrder = projectOrder.get(b.projectId || '') ?? 0;
      return aOrder - bOrder;
    });
  }, [isInsideProject, projectDrafts, allDrafts]);

  if (!drafts.length || !hasAccess) return null;

  return <DraftButtonWithDialog drafts={drafts} />;
};
